import {baseServer} from "@/server/base";

export class personalServer extends baseServer{

	getShowName(){
		return this.name;
	}

	can(permission){
		if(this.permission===null){
			return true;
		}
		if(permission===true){
			return false;
		}
		if(!permission.module){
			return false;
		}
		if(!this.permission[permission.module]){
			return false;
		}
		if(!permission.action){
			return true;
		}
		if(this.permission[permission.module].indexOf(permission.action)==-1){
			return false;
		}
		return true;
	}

}



// WEBPACK FOOTER //
// ./src/server/personal.js